<template>
    <message-container>
        <message-list @tabs-change="onTabsChange"
                      @all-read="onAllRead"
                      @previous="onPrevious"
                      @next="onNext"
                      @search="onSearch">
            <message-list-item
                    v-if="messageItems.length > 0"
                    v-for="(messageItem, index) in messageItems" :key="index"
                    :send-user="messageItem[props.sendUnit]"
                    :send-date="messageItem[props.sendDate]"
                    :title="messageItem[props.title]"
                    :content="messageItem[props.content]"
                    :new-message="messageItem.flag === '0'"
                    :index="index"
                    :current-index="currentIndex"
                    @mail-change="onListItemClick"
            ></message-list-item>
            <div class="mail-empty-title" v-if="messageItems.length === 0">无数据</div>
        </message-list>
        <message-content :send-user="currentItem[props.sendUser]"
                         :send-date="currentItem[props.sendDate]"
                         :send-unit="currentItem[props.sendUnit]"
                         :title="currentItem[props.title]"
                         :content="currentItem[props.content]" v-show="typeof currentItem[props.title] !== 'undefined'"></message-content>
    </message-container>
</template>

<script>
import MessageContainer from "@/views/Messages/components/MessageContainer";
import MessageList from "@/views/Messages/components/MessageList";
import MessageListItem from "@/views/Messages/components/MessageListItem";
import MessageContent from "@/views/Messages/components/MessageContent";
export default {
    name: "index",
    components: {
        MessageContent,
        MessageContainer,
        MessageList,
        MessageListItem
    },
    data () {
        return {
            currentIndex: 0,
            currentItem: {}
        }
    },
    props: {
        props: {
            type: Object,
            default () {
                return {
                    sendUser: 'sendUser',
                    sendUnit: 'sendUnit',
                    sendDate: 'sendDate',
                    title: 'title',
                    content: 'content',
                    newMail: 'newMail'
                }
            },
            validate(value){
                this.Tools.get()
                    .ObjectTools.merge(value,{
                    sendUser: 'sendUser',
                    sendDate: 'sendDate',
                    title: 'title',
                    content: 'content',
                    newMail: 'newMail'
                })
            }
        },
        messageItems: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        onAllRead () {
            this.$emit('all-read')
        },
        onSearch (searchData) {
            this.$emit('search', searchData)
        },
        onTabsChange (name) {
            this.$emit('tabs-change', name)
        },
        onPrevious () {
            this.$emit('previous')
        },
        onNext (){
            this.$emit('next')
        },
        onListItemClick(index) {
            const $this = this
            this.currentIndex = index
            this.currentItem = this.messageItems[index]
            this.$emit('read-mail', this.currentItem)
        },
        onRead(){
            let data = this.$refs['mail'].getCheckedItems()
            this.$message.info(JSON.stringify(data))
        }
    },
    watch: {
        messageItems: {
            deep: true,
            handler(nv, ov){
            }
        }
    }
}
</script>

<style scoped lang="scss">
.mail-empty-title{
    color: #808080;
    text-align: center;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/Messages/index.vue"
}
</vue-filename-injector>
